function hashCode(...strings) {
    const str = strings.join('');
    if (str.length === 0) {
        return 0;
    }
    let hash = 0;
    for (let index = 0; index < str.length; index++) {
        hash = ((hash << 5) - hash) + str.charCodeAt(index);
        hash |= 0;
    }
    return hash;
}
export default hashCode;
//# sourceMappingURL=hash-code.js.map